exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-breadcrumb{font-size:1.7em;margin-bottom:20px;margin-top:10px}", ""]);

// exports
